module.exports = __webpack_public_path__ + "media/images/products/category/4-ed270653e886f00c5ee6d08af7a0f3a7.jpg";